import {
    NumberInput, ArrayInput, SimpleFormIterator, 
    maxLength, useGetOne, AutocompleteInput,
    useTranslate,
} from 'react-admin';

import { Box } from '@material-ui/core';

import {
    Storage
} from '@material-ui/icons';
import { useFormContext } from 'react-hook-form';
import { useEffect } from 'react';
import SectionField from './sectionField';
import DiskBusHelpModal from './diskBusHelp';
import convertByte from '../utils/convertByte';

const GetImage = (imageId, classes) => {
    const { data: imageData, isLoading, error } = useGetOne('images', { id: imageId });
    const { setValue } = useFormContext();
    const translate = useTranslate();

    useEffect(() => {
        if (!isLoading && imageData) {
            if (imageData.disks[0].format === 'qcow2' || imageData.disks[0].format === 'vmdk' || imageData.disks[0].format === 'raw') {
                let virtualSize = convertByte(imageData.disks[0].virtualSize, 'GB');
                virtualSize = parseInt(virtualSize.replace('GB', ''));

                // Only set value when image is loaded
                setValue('volumeSize', virtualSize);
            }
        }
    }, [isLoading, imageData, setValue]);

    if (isLoading) {
        return <div>{'app.LoadingMessage'}</div>;
    }

    if (imageData.disks[0].format === 'qcow2' || imageData.disks[0].format === 'vmdk' || imageData.disks[0].format === 'raw') {
        return (
            <>
                <SectionField label={translate('app.vms.create.disk')} icon={Storage} />
                <NumberInput source='volumeSize' min='0' label={translate('volume (GB)')} />
                <Box className={classes.flexBox}>
                    <AutocompleteInput source='busType' choices={[
                        { id: 'virtio', name: 'virtio' },
                        { id: 'scsi', name: 'scsi' },
                        { id: 'ide', name: 'ide' },
                    ]} defaultValue='virtio' />
                    <DiskBusHelpModal /> {/* Add the help button next to the AutocompleteInput */}
                </Box>
            </>
        )
    }
    else {
        return (
            <>
                <SectionField label={translate('app.vms.create.disk')} icon={Storage} />

                <ArrayInput source='emptyVolume' label={translate('app.vms.create.emptyVolumes')}>
                    <SimpleFormIterator getItemLabel={index => `#${index + 1}`} limit={3}>
                        <NumberInput label='Size' source='size' min='0' />
                        <Box className={classes.flexBox}>
                            <AutocompleteInput source='busType' choices={[
                                { id: 'virtio', name: 'virtio' },
                                { id: 'scsi', name: 'scsi' },
                                { id: 'ide', name: 'ide' },
                            ]} defaultValue='virtio' />
                            <DiskBusHelpModal /> {/* Add the help button next to the AutocompleteInput */}
                        </Box>
                    </SimpleFormIterator>
                </ArrayInput>
            </>)
    }
};

export default GetImage;